/**
 * lazy-img
 * 依赖 jieyou_lazyload
 *
 * 若使用 `scrollstop` 事件，需依赖 jquery-scrollstop
 *
 * TODO:
 *      1. 每个组件实例可以使用单独的配置
 *      2. 可以配置全局的默认配置
 *      3. 增加一个 lazyImgContainer 的指令，在这个容器下的 lazyImg 自动使用该容器作为 scroll 事件监听对象
 */

!function () {
    var directiveName = 'lazyImg'
        , lazyPluginAttribute = 'lazyload-url'
        , lazyloadDefaultOptions = {
            threshold: 255,
            data_attribute: lazyPluginAttribute,
            event: "scrollstop",
            // effect: "fadeIn",
            failure_limit: 6,
            placeholder_real_img: '/images/common/placeholder-pure-silver.png',
        }
        , loadedImg = {}
    ;

    angular.module('app.extra.lazyLoad')
        .directive('lazyImg', lazyImgDirective)

    function lazyImgDirective() {
        return {
            priority: 99, // it needs to run after the attributes are interpolated // todo: ?
            restrict: 'A',
            link: link,
        };

        function link(scope, element, attr) {
            var lazyImgAttribute = 'data-' + lazyPluginAttribute
            ;

            attr.$observe(directiveName, function (value) {
                if (!value) {
                    return;
                }
                attr.$set(lazyImgAttribute, value);
                element.lazyload(angular.extend({}, lazyloadDefaultOptions, {load: imageOnLoad}));
            });
        }

        function imageOnLoad($elements, elements_left, options) {
            var src = $elements.attr('src');
            loadedImg[src] = true;
        }
    }
}();